import React from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'
import Report from '../components/Report'
import UpperHeader from '../components/UpperHeader'
import 'react-quill/dist/quill.snow.css';
import { useAlert } from "react-alert";

export default function AboutUs() {
    let alert = useAlert();
    const [AboutUs, setAboutUs] = React.useState('');

    React.useEffect(() => {
        getAboutUs()
    }, [])

    const getAboutUs = () => {
        fetch(
            `${process.env.REACT_APP_URL_API}/data/getAboutUs`,
            {
                method: "GET",
                mode: "cors",
                headers: {
                    "Content-Type": "application/json",
                    "Cache-Control": "no-cache",
                    "Access-Control-Allow-Origin": "*",
                },
            }
        )
            .then((response) => response.json())
            .then((data) => {
                setAboutUs(data[0].content);
            })
            .catch((error) => {
                alert.show("Ocurrió un error al obtener los datos", {
                    timeout: 3000,
                    type: "error",
                });
            });
    }
    return (
        <div>
            <UpperHeader child={false} />
            <Header />
            <Report />
            <div className="text-center p-2 pt-3">
                <p className='colorblue'><h2 className='fw-bold fst-italic'>¿Quiénes Somos?</h2></p>
            </div>
            <img src="linea-de-color.jpg" alt='Linea Color' className='img-fluidLine reverse' style={{ marginBottom: "22px" }} />
            <pre>
                {AboutUs ? <>
                    <div className="container" style={{ overflow: "hidden" }}>
                        <span className="view ql-editor" style={{ fontSize: "1rem" }} dangerouslySetInnerHTML={{ __html: AboutUs }} />
                    </div>
                </> : <>
                    <div className='text-center'>
                        <p>Cargando...</p>
                    </div>
                </>}
            </pre>
            <Footer showmap={false} />
        </div>
    )
}
